<template>
  <div>
    <vs-prompt
      :vs-title="'Transfer #' + serviceId"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-close="cancel"
      @vs-cancel="cancel"
      :vs-active.sync="visible"
      vs-accept-text="Kaydet"
      @vs-accept="submit"
      :vs-is-valid="validateForm"
    >
      <vcl-table secondary="#ff9f43" v-if="loading"></vcl-table>
      <div class="vx-row ml-5 mr-5" v-if="!loading">
        <div
          class="vx-row ml-5 mr-5"
          v-if="currentItem.transferStatus<0 || currentItem.transferStatus==2"
        >
          <p>Transfer edilecek servis</p>
          <div class="vx-row w-full mb-5">
            <p class="w-full mb-5 ml-5">Transfer Yönü</p>
            <vs-radio v-model="picked" vs-value="1" class="ml-5 mr-10" name="rdbSube">Şubeye</vs-radio>
            <vs-radio v-model="picked" vs-value="2" name="rdbProducer">Üreticiye</vs-radio>
          </div>
          <div class="vx-row w-full" v-if="picked==1">
            <span class="w-full mb-5 ml-5">Şubeye Transfer</span>
            <v-select
              class="w-1/4 mb-10 ml-5"
              v-model="selectedSube"
              placeholder="Şube seçiniz"
              name="selectedSube"
              v-validate="'required'"
              :options="subeler"
              label="value"
            >
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-row w-full" v-if="picked==2">
            <span class="w-full">Üreticiye Transfer</span>
          </div>
          <vs-input
            class="w-full"
            placeholder="'Transfer Açıklaması Giriniz'"
            v-validate="'required'"
            v-model="transferDetails"
            name="txtTransferDetails"
          ></vs-input>
        </div>
        <div v-if="currentItem.transferStatus>-1">
          <vs-checkbox
            v-model="chkKargoyaVerildi"
            v-if="currentItem.transferStatus==0"
          >Kargoya verildi</vs-checkbox>
          <vs-checkbox v-model="chkKargoUlasti" v-if="currentItem.transferStatus==1">Teslim Alındı</vs-checkbox>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import { VclTable } from "vue-content-loading";
import vSelect from "vue-select";

export default {
  components: {
    VclTable,
    vSelect
  },
  props: {
    serviceId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      asd: [{ value: 1 }, { value: 2 }],
      visible: true,
      loading: true,
      picked: 1,
      transferDetails: "",
      selectedSube: "",
      subeler: [],
      selectValidate: "",
      currentItem: {},
      chkKargoyaVerildi: false,
      chkKargoUlasti: false
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.transferDetails != "" && this.selectedSube != "";
    }
  },
  created() {
    this.getData();
    
  },
  methods: {
    getData: async function() {
      let olist = await repository
        .getAll("user/getOfficeList")
        .then(r => r.list)
        .catch(error => {
          this.$vs.notify({
            color: "danger",
            title: `${error}`,
            text: "İşlem tamamlanamadı.Bilinmeyen Hata!"
          });
          this.loading = false;
          //this.cancel();
        });
      this.currentItem = await repository
        .postEntity("technic/getOrders", {
          userID: this.$store.state.userData.userId,
          serviceID: this.serviceId
        })
        .then(r => r.list)
        .then(r => r[0])
        .catch(error => {
          this.$vs.notify({
            color: "danger",
            title: `${error}`,
            text: "İşlem tamamlanamadı.Bilinmeyen Hata!"
          });
          this.loading = false;
          //this.cancel();
        });
      if (!this.loading) return;
      this.subeler = olist;
      this.selectValidate = "included:";
      for (let i = 0; i < olist.length; i++) {
        this.selectValidate += olist[i].id + (i == olist.length - 1 ? "" : ",");
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    cancel() {
      this.visible = true;
      this.$emit("updateCompleted", 0);
    },
    submit() {
      if (this.selectedSube == "") this.selectedSube = -1;
      this.visible = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          let postModel = {
            serviceId: this.serviceId,
            serviceNote: this.transferDetails,
            direction: this.picked,
            transferTo: this.selectedSube.id
          };
          let message = "";
          if (
            this.currentItem.transferStatus == -1 ||
            this.currentItem.transferStatus == 2
          ) {
            //transfer başlayacak...
            message = "Transfer kaydı oluşturuldu";
          }
          if (this.currentItem.transferStatus == 0) {
            message = "Transfer diğer şubeye gönderildi";
          }
          if (this.currentItem.transferStatus == 1) {
            message = "Transfer işlemi tamamlandı";
          }

          repository
            .postEntity("Technic/transferTechnicalOrder", postModel)
            .then(r => {
              if (!r || r.hasExceptionError || !r.isSuccessful) {
                console.warn(r.exceptionMessage);
              }
              if (r) {
                if (r.isSuccessful) {
                  this.$vs.notify({
                    color: "success",
                  time:3000,
                  icon:"check",
                    title: `${message}`,
                    text: "İşlem başarıyla tamamlandı!"
                  });
                } else if (r.hasExceptionError) {
                  this.$vs.notify({
                    color: "danger",
                  time:3000,
                  icon:"warning",
                    title: `${r.exceptionMessage}`,
                    text: "İşlem tamamlanamadı.Bilinmeyen Hata!"
                  });
                } else {
                  this.$vs.notify({
                    color: "warning",
                  time:3000,
                  icon:"warning",
                    title: "Hızlı İşlem",
                    text: "İşlem tamamlanamadı.Bilinmeyen Hata!"
                  });
                }
              } else {
                this.$vs.notify({
                  color: "warning",
                  time:3000,
                  icon:"warning",
                  title: "Hızlı İşlem",
                  text: "İşlem tamamlanamadı.Bilinmeyen Hata!",
                  
                });
              }
            })
            .catch(error => {
              console.warn(error);
            });
          this.$emit("updateCompleted", this.serviceId);
        }
      });
    }
  }
};
</script>
